import { useEffect, useState } from "react";
import { FaPhoneAlt, FaRegClock, FaSearch } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { FaRegCalendar } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { LuMessageCircle } from "react-icons/lu";
import { FaCarAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import BannerCarousel from "../components/BannersCarousel";
import { formatMoney } from "../utils/formatMoney";
import { BiArrowToLeft, BiArrowToRight } from "react-icons/bi";

const firestore = getFirestore(app);

export default function Home() {
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });
  const [, setErroFiltro] = useState("");

  // Carrossel de carros vendidos (fotos em slides de 5)
  // Substitua os caminhos abaixo pelos arquivos reais quando enviar ao site
  const [soldSlide, setSoldSlide] = useState(0);
  const soldCars = [
    "/vendidos/27.jpg",
    "/vendidos/28.jpg",
    "/vendidos/29.jpg",
    "/vendidos/30.jpg",
    "/vendidos/31.jpg",
    "/vendidos/32.jpg",
    "/vendidos/33.jpg",
    "/vendidos/34.jpg",
    "/vendidos/35.jpg",
    "/vendidos/36.jpg",
    "/vendidos/38.jpg",
    "/vendidos/39.jpg",
    "/vendidos/40.jpg",
    "/vendidos/41.jpg",
    "/vendidos/1.jpeg",
    "/vendidos/2.jpeg",
    "/vendidos/3.jpeg",
    "/vendidos/4.jpeg",
    "/vendidos/5.jpeg",
    "/vendidos/6.jpeg",
    "/vendidos/7.jpeg",
    "/vendidos/8.jpeg",
    "/vendidos/9.jpeg",
    "/vendidos/10.jpeg",
    "/vendidos/11.jpeg",
    "/vendidos/12.jpeg",
    "/vendidos/13.jpeg",
    "/vendidos/14.jpeg",
    "/vendidos/15.jpeg",
    "/vendidos/16.jpeg",
    "/vendidos/17.jpeg",
    "/vendidos/18.jpeg",
    "/vendidos/19.jpeg",
    "/vendidos/20.jpeg",
    "/vendidos/21.jpeg",
    "/vendidos/22.jpeg",
    "/vendidos/23.jpeg",
    "/vendidos/24.jpeg",
    "/vendidos/25.jpeg",
    "/vendidos/26.jpeg",
  ];
  const soldSlides = [];
  for (let i = 0; i < soldCars.length; i += 5) {
    soldSlides.push(soldCars.slice(i, i + 5));
  }

  // Feedbacks: 2 fotos por slide
  const [feedbackSlide, setFeedbackSlide] = useState(0);
  const [feedbackAutoplay, setFeedbackAutoplay] = useState(true);
  const feedbackImages = [
    "/feedbacks/15.jpeg",
    "/feedbacks/16.jpeg",
    "/feedbacks/17.jpeg",
    "/feedbacks/18.jpeg",
    "/feedbacks/19.jpeg",
    "/feedbacks/20.jpeg",
    "/feedbacks/21.jpeg",
    "/feedbacks/22.jpeg",
    "/feedbacks/23.jpeg",
    "/feedbacks/24.jpeg",
    "/feedbacks/9.jpeg",
    "/feedbacks/10.jpeg",
    "/feedbacks/11.jpeg",
    "/feedbacks/12.jpeg",
    "/feedbacks/13.jpeg",
    "/feedbacks/14.jpeg",
    "/feedbacks/1.jpeg",
    "/feedbacks/2.jpeg",
    "/feedbacks/3.jpeg",
    "/feedbacks/4.jpeg",
    "/feedbacks/5.jpeg",
    "/feedbacks/6.jpeg",
    "/feedbacks/7.jpeg",
    "/feedbacks/8.jpeg",
  ];
  const feedbackSlides = [];
  for (let i = 0; i < feedbackImages.length; i += 2) {
    feedbackSlides.push(feedbackImages.slice(i, i + 2));
  }

  const navigate = useNavigate();

  // Autoplay do carrossel de feedbacks
  useEffect(() => {
    if (!feedbackAutoplay || feedbackSlides.length === 0) return;
    
    const interval = setInterval(() => {
      setFeedbackSlide((prev) => (prev + 1) % feedbackSlides.length);
    }, 4000); // Muda de slide a cada 4 segundos
    
    return () => clearInterval(interval);
  }, [feedbackAutoplay, feedbackSlides.length]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        setRevenda(docSnap.data());
      }
    });

    const q = query(
      collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
      where("veremovido", "==", 0),
      where("vevendido", "==", 0),
      orderBy("updated_at", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        const document = doc.data();
        document.id = doc.id;
        if (document["veexibir_site"] !== false) {
          items.push(document);
        }
      });
      setVeiculos(items);
    });

    return () => unsubscribe();
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <div className="flex flex-col items-center text-center sm:mt-12 space-y-2">
        <BannerCarousel />

        <div className="relative flex flex-col items-center justify-center text-black text-center px-2 sm:px-4">
          <h1 className="text-3xl sm:text-4xl md:text-6xl mt-8 font-bold mb-2 sm:mb-4">SP Car's</h1>
          <p className="text-base sm:text-lg md:text-xl mb-4 sm:mb-8">
            Realizando sonhos com qualidade e confiança
          </p>

          <div className="bg-white rounded-xl flex flex-col gap-2 md:gap-4 p-3 sm:p-6 shadow-lg w-full max-w-lg sm:max-w-2xl md:max-w-3xl">
            <div className="flex flex-col items-center md:flex-row gap-2 md:gap-4">
              <select
                className="p-2 rounded-md border border-gray-300 text-black w-full md:w-1/3"
                value={filtros.marca}
                onChange={e => {
                  setFiltros(f => ({ ...f, marca: e.target.value }));
                  setErroFiltro("");
                }}
              >
                <option value="">Marca</option>
                {getOpcoesFiltro("vefipe_marca").map(marca => (
                  <option key={marca} value={marca}>{marca}</option>
                ))}
              </select>

              <div className="relative w-full md:w-1/3">
                <select
                  className="p-2 rounded-md border border-gray-300 text-black w-full"
                  value={filtros.modelo}
                  onChange={e => setFiltros(f => ({ ...f, modelo: e.target.value, ano: "" }))}
                >
                  <option value="">Modelo</option>
                  {getOpcoesFiltro("vefipe_name", filtros.marca)
                    .map(modelo => (
                      <option key={modelo} value={modelo}>{modelo}</option>
                    ))}
                </select>
              </div>

              <div className="relative w-full md:w-1/3">
                <select
                  className="p-2 rounded-md border border-gray-300 text-black w-full"
                  value={filtros.ano}
                  onChange={e => {
                    setFiltros(f => ({ ...f, marca: e.target.value, modelo: "", ano: "" }));
                    setErroFiltro("");
                  }}
                >
                  <option value="">Ano</option>
                  {getOpcoesFiltro("vefipe_ano_modelo")
                    .map(ano => (
                      <option key={ano} value={ano}>{ano}</option>
                    ))}
                </select>
              </div>

              <div className="flex flex-col sm:flex-row gap-2 mt-2">
                {(filtros.marca || filtros.modelo || filtros.ano) && (
                  <button
                    className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md font-semibold whitespace-nowrap w-full sm:w-auto"
                    type="button"
                    onClick={() => {
                      setFiltros({ marca: "", modelo: "", ano: "" });
                      setErroFiltro("");
                    }}
                  >
                    Limpar filtros
                  </button>
                )}

                <button
                  className="flex items-center justify-center gap-2 bg-[#CFAD5D] text-white px-4 py-2 rounded-md w-full sm:w-auto"
                  onClick={handleBuscar}
                  type="button"
                >
                  <FaSearch /> Buscar
                </button>
              </div>
            </div>

            <div className="flex justify-center mt-4">
              <div className="w-full">
                <FiltrosAvancados
                  filtros={filtrosAvancados}
                  setFiltros={setFiltrosAvancados}
                />
              </div>
            </div>
          </div>
        </div>

        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold mt-18">Veículos em Destaque</h2>
        <p className="text-gray-800 text-base sm:text-xl">Selecionamos os melhores veículos com preços especiais para você</p>
      </div>


      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6 max-w-6xl mx-auto px-4">
        {veiculos
          .slice()
          .sort(() => Math.random() - 0.5)
          .slice(0, 3)
          .map((veiculo) => (
            <div key={veiculo.id} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col">
              <img src={veiculo.imagens[0]?.fileUrl} alt={veiculo.titulo} />
              <div className="p-4 flex-1 flex flex-col justify-between">
                <h3 className="text-lg font-bold mb-2 uppercase">
                  {veiculo.vefipe_marca} {veiculo.vefipe_name}
                </h3>
                <div className="flex flex-wrap justify-between text-sm text-gray-600">
                  <span><MdSpeed /> {veiculo.vequilometragem}km</span>
                  <span><BiGasPump /> {veiculo.vefipe_combustivel}</span>
                  <span><FaRegCalendar /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}</span>
                </div>

                <div className="vehicle-observation p-2 mt-2 rounded" style={{
                  backgroundColor: '#f8f9fa',
                  borderLeft: '4px solid #ff4d4f',
                  fontSize: '0.9rem',
                  color: '#333',
                  lineHeight: '1.4',
                }}>
                  <p>{veiculo.veobservacao}</p>
                </div>


                <div>
                  <p className="text-xl font-bold mt-2">
                    {veiculo.vevalor ? formatMoney(veiculo.vevalor) : "Consulte o preço"}
                  </p>
                </div>

                <div className="mt-4 flex gap-2">
                  <a href={`/veiculo/${veiculo.id}`} className="bg-[#F21326] text-white px-4 py-2 rounded flex gap-2 items-center">
                    <FiEye /> Ver Detalhes
                  </a>
                  <a
                    href={`https://api.whatsapp.com/send?phone=55${retiraMascara(revenda.petelefone2, "link")}`}
                    className="border border-[#F21326] text-[#F21326] font-bold px-4 py-2 rounded flex items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LuMessageCircle />
                  </a>
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className="text-center mt-8">
        <a
          className="bg-[#CFAD5D] text-white px-6 py-3 rounded-md text-lg font-semibold inline-flex gap-2 items-center"
          href="/estoque"
        >
          <FaCarAlt /> Ver Todo o Estoque
        </a>
      </div>


      {/* Carrossel de Carros Vendidos */}
      <div className="flex flex-col items-center text-center mt-12 sm:mt-20 space-y-2">
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold">Carros Vendidos</h2>
        <p className="text-gray-800 text-base sm:text-xl">Alguns veículos já entregues aos nossos clientes</p>
      </div>
      <div className="relative max-w-7xl mx-auto mt-4 sm:mt-6 px-2">
        <button
          type="button"
          aria-label="Anterior"
          onClick={() => setSoldSlide((prev) => (prev - 1 + soldSlides.length) % soldSlides.length)}
          className="hidden sm:flex absolute -left-4 md:-left-6 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-gray-800 border border-gray-200 rounded-full w-10 h-10 items-center justify-center shadow"
        >
          ‹
        </button>
        <button
          type="button"
          aria-label="Próximo"
          onClick={() => setSoldSlide((prev) => (prev + 1) % soldSlides.length)}
          className="hidden sm:flex absolute -right-4 md:-right-6 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white text-gray-800 border border-gray-200 rounded-full w-10 h-10 items-center justify-center shadow"
        >
          ›
        </button>
        {/* Slides */}
        <div className="overflow-hidden rounded-xl">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${soldSlide * 100}%)` }}
          >
            {soldSlides.map((slide, idx) => (
              <div key={idx} className="w-full flex-shrink-0 px-1 sm:px-2">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2 sm:gap-3">
                  {slide.map((src, i) => (
                    <div key={i} className="bg-white rounded-xl shadow overflow-hidden">
                      <div className="relative w-full aspect-square">
                        <img
                          src={src}
                          alt={`Carro vendido ${idx * 5 + i + 1}`}
                          className="absolute inset-0 w-full h-full object-cover"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto mt-4 sm:mt-6 px-2">
        {/* Navegação */}


        <div className="flex flex-col items-center text-center mt-12 sm:mt-20 space-y-2">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold">Feedbacks!</h2>
          <p className="text-gray-800 text-base sm:text-xl">Confira o que nossos clientes tem a dizer!</p>
        </div>

        <div className="relative max-w-7xl mx-auto mt-4 sm:mt-6 px-2">
          {/* Navegação */}
          <button
            type="button"
            aria-label="Anterior"
            onClick={() => {
              setFeedbackAutoplay(false);
              setFeedbackSlide((prev) => (prev - 1 + feedbackSlides.length) % feedbackSlides.length);
            }}
            className="hidden sm:flex absolute -left-12 md:-left-16 top-1/2 -translate-y-1/2 z-10 bg-black/80 hover:bg-white text-white hover:text-black border border-gray-200 rounded-full w-16 h-16 items-center justify-center shadow text-2xl"
          >
            <BiArrowToLeft/>
          </button>
          <button
            type="button"
            aria-label="Próximo"
            onClick={() => {
              setFeedbackAutoplay(false);
              setFeedbackSlide((prev) => (prev + 1) % feedbackSlides.length);
            }}
            className="hidden sm:flex absolute -right-12 md:-right-16 top-1/2 -translate-y-1/2 z-10 bg-black/80 hover:bg-white text-white hover:text-black border border-gray-200 rounded-full w-16 h-16 items-center justify-center shadow text-2xl"
          >
            <BiArrowToRight/>
          </button>

          {/* Slides */}
          <div className="overflow-hidden rounded-xl">
            <div
              className="flex transition-transform duration-500"
              style={{ transform: `translateX(-${feedbackSlide * 100}%)` }}
            >
              {feedbackSlides.map((slide, idx) => (
                <div key={idx} className="w-full flex-shrink-0 px-1 sm:px-2">
                  <div className="grid grid-cols-2 gap-2 sm:gap-3">
                    {slide.map((src, i) => (
                      <div key={i} className="bg-white rounded-xl shadow overflow-hidden">
                        <div className="relative w-full aspect-square">
                          <img
                            src={src}
                            alt={`Feedback ${idx * 2 + i + 1}`}
                            className="absolute inset-0 w-full h-full object-cover"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4">
            {feedbackSlides.map((_, i) => (
              <button
                key={i}
                type="button"
                aria-label={`Ir para o slide ${i + 1}`}
                onClick={() => setFeedbackSlide(i)}
                className={`h-2 w-2 rounded-full ${feedbackSlide === i ? "bg-[#CFAD5D] w-6" : "bg-gray-300"}`}
              />
            ))}
          </div>
        </div>

        {/* Seção de contato + mapa */}
        <section className="py-8 sm:py-12 px-2 sm:px-4 md:px-8 bg-white">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-center text-neutral-900 mt-10 sm:mt-20">Visite Nossa Loja</h2>
            <p className="text-center text-gray-800 text-base sm:text-xl mt-2 mb-6 sm:mb-10">
              Uma experiência completa para você encontrar o carro ideal
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-start">
              <div className="space-y-4 sm:space-y-6">
                <h3 className="text-lg sm:text-xl font-semibold text-neutral-800">Entre em Contato</h3>

                <div className="flex items-center gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                  <div className="bg-[#CFAD5D] text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-700">Telefone</p>
                    <p className="text-[#003c85] font-semibold">{retiraMascara(revenda.petelefone1)}</p>
                  </div>
                </div>

                <div className="flex items-center gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                  <div className="bg-[#CFAD5D] text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                    <LuMessageCircle />
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-700">WhatsApp</p>
                    <p className="text-[#003c85] font-semibold">{retiraMascara(revenda.petelefone2)}</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                  <div className="bg-[#CFAD5D] text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                    <FaLocationDot />
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-700">Endereço</p>
                    <p className="text-neutral-600">
                      {revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal}
                    </p>
                    <p className="text-neutral-600">{revenda.pecidade} – {revenda.peuf}</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                  <div className="bg-[#CFAD5D] text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                    <FaRegClock />
                  </div>
                  <div>
                    <p className="font-semibold text-neutral-700">Horário</p>
                    <p className="text-neutral-600">Segunda à Sexta: 8:00 às 18:00</p>
                    <p className="text-neutral-600">Sábado: 8:00 às 12:00</p>
                  </div>
                </div>
              </div>

              <div>
                <iframe
                  className="w-full h-64 sm:h-[400px] rounded-xl shadow-md"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3658.542567866983!2d-46.60957722391566!3d-23.51298025981804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce58bb9baac71f%3A0xf1d83c51434c7b80!2sAv.%20Joaquina%20Ramalho%2C%20411%20-%20Vila%20Guilherme%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2002065-010!5e0!3m2!1spt-BR!2sbr!4v1759842133267!5m2!1spt-BR!2sbr"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa da Loja"
                ></iframe>
              </div>
            </div>
          </div>
        </section>

      </div>

      <Footer />
    </div >
  );
}
